import React from 'react'
import ReactTooltip from 'react-tooltip';
import {IconInfo} from '../../images/';


const Tooltip = ({ title = "", text = "", id = "" }) => {
    return (
        <>
            <a data-tip data-for={id} src="">
                <IconInfo width={13} />
            </a>
            < ReactTooltip   offset = {{right:50}} className="tooltip-ca" id={id} place="top" type="light" effect='solid'  wrapper="span">
                <div className="">
                    <div className="tooltip-header-ca">
                    <IconInfo width={15} />
                        <p className="tooltip-header-elemnts-ca">{title}</p>
                    </div>
                    <div className="tooltip-body-ca">
                        {text}
                    </div>
                </div>
            </ReactTooltip>
        </>
    );
}

export { Tooltip };